import { DashboardOverviewStoreModel } from '@domain/multi-site-dashboard/multi-site-dashboard.models';
import { ChargerOperationalStatusStoreModelEnum } from '@domain/sites/sites.enums';

import { ChargersOverviewMovablePanelViewModel } from '../components/chargers-overview-movable-panel';
import { SiteFleetsOverviewMovablePanelViewModel } from '../components/site-fleets-overview-movable-panel';

// One at-a-glance card per fleet site, built from the aggregated per-site fleet overview.
export const mapDashboardOverviewToSiteFleetsOverviewMovablePanelViewModel = (
  overview: DashboardOverviewStoreModel
): SiteFleetsOverviewMovablePanelViewModel => ({
  cards: overview.fleetPerSite.map((site) => ({
    siteId: site.siteId,
    siteName: site.depotName,
    siteTenant: '',
    vehiclesPerState: site.statusData,
    hideTenantName: true,
  })),
});

export const mapDashboardOverviewToChargersOverviewMovablePanelViewModel = (
  overview: DashboardOverviewStoreModel
): ChargersOverviewMovablePanelViewModel => ({
  chargers: {
    [ChargerOperationalStatusStoreModelEnum.Operational]: {
      count: overview.chargerOverview[ChargerOperationalStatusStoreModelEnum.Operational]?.count ?? 0,
    },
    [ChargerOperationalStatusStoreModelEnum.Offline]: {
      count: overview.chargerOverview[ChargerOperationalStatusStoreModelEnum.Offline]?.count ?? 0,
      siteCount: overview.chargerOverview[ChargerOperationalStatusStoreModelEnum.Offline]?.siteCount ?? 0,
    },
    [ChargerOperationalStatusStoreModelEnum.Faulted]: {
      count: overview.chargerOverview[ChargerOperationalStatusStoreModelEnum.Faulted]?.count ?? 0,
      siteCount: overview.chargerOverview[ChargerOperationalStatusStoreModelEnum.Faulted]?.siteCount ?? 0,
    },
    [ChargerOperationalStatusStoreModelEnum.Maintenance]: {
      count: overview.chargerOverview[ChargerOperationalStatusStoreModelEnum.Maintenance]?.count ?? 0,
      siteCount: overview.chargerOverview[ChargerOperationalStatusStoreModelEnum.Maintenance]?.siteCount ?? 0,
    },
  },
});
